import { Link } from '@billy/design-system'
import ReactDOM from 'react-dom'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useAppEnvironment } from '../../hooks/useAppEnvironment'
import { getOrganizationViewUrl } from '../../utils/routing/getOrganizationViewUrl'
import * as Styled from './styles'

export const EnvironmentIndicator = () => {
  const { organization } = useUserOrganization()
  const { environment } = useAppEnvironment()
  const debugUrl = getOrganizationViewUrl(organization?.url, '/debug')

  if (environment === 'production') {
    return null
  }

  return ReactDOM.createPortal(
    <Styled.EnvironmentIndicatorContainer>
      <Link to={debugUrl}>
        <Styled.EnvironmentPill environment={environment}>{environment}</Styled.EnvironmentPill>
      </Link>
    </Styled.EnvironmentIndicatorContainer>,
    document.body,
  )
}
